import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Apartment, Trip } from '@/types';
import { apartmentService } from '@/services/apartmentService';
import ApartmentCard from '@/components/apartment/ApartmentCard';

interface ApartmentListProps {
  trip: Trip;
}

const ApartmentList: React.FC<ApartmentListProps> = ({ trip }) => {
  const [apartments, setApartments] = useState<Apartment[]>([]);

  useEffect(() => {
    if (!trip.id) return;
    const unsubscribe = apartmentService.listenToApartments(trip.id, setApartments);
    return () => unsubscribe();
  }, [trip.id]);

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={3}>
        {apartments.map((apartment) => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={apartment.id}>
            <ApartmentCard apartment={apartment} trip={trip} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ApartmentList;
